export default __webpack_public_path__ + "static/media/School Program - Class 12.6398457d.jpg";